export const HumanReadableErrors = {
  noInternetConnection:
    "No internet connection.\n Please check that your internet connection is working and try again.",
  sessionExpired: "Your session has expired. Please login again to continue working.",
  unknown:
    "Something went wrong! Automatic report has been send to the TigerConnect tech team to improve your experience.",
};
